import type { FeedbackCreateDto, FeedbackResponseDto } from 'types/feedback';
import { portalAPI } from './portalAPI';

export const APIFeedbackSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        addUserFeedback: builder.mutation<FeedbackResponseDto, FeedbackCreateDto>({
            query: ({ ...body }) => ({
                url: `/v1/feedback`,
                method: 'POST',
                body,
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useAddUserFeedbackMutation } = APIFeedbackSlice;
